import React from "react";
import { NavLink } from "react-router-dom";

const Departments = ({ departments, loading }) => {
    return (
        <div className="departments">
            <div className="content">
                <div className={`card ${loading && ' loading'}`}>
                    {loading ? (
                        [...Array(8)].map((_, i) => (
                            <div className="card-content" key={i}>
                                <a>
                                    <i className="fa fa-folder"></i>
                                    <span>Loading...</span>
                                </a>
                            </div>
                        ))
                    ) : (
                        departments?.map((item, i) => (
                            <div key={i} className="card-content">
                                <NavLink to={`/nd-ot/all-requests/${item.department_code}?label=${item.department}`} title={item.department_code} aria-label={`Navigate to department NDOT requests for ${item.department_code}`}>
                                    <i className="fa fa-folder"></i> 
                                    <span>{item.department}</span>
                                </NavLink>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    )
}

export default Departments;